import axios from "axios";

const server = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    headers: { 'Content-Type': 'application/json' }
});


export class EcommerceManagerFetchAPI {

    // Function to get the content of the ecommerce manager
    static async getContent(businessId, token) {
        const res = await server(`/ecommerce/${businessId}/content`, {
            method: "get",
            headers: { 'x-access-token': token },
        });
        return res;
    }

    // Function to create new content in the ecommerce manager
    static async postContent(businessId, data, token) {
        const res = await server(`/ecommerce/${businessId}/content`, {
            method: "post",
            data: data,
            headers: { 'Content-Type': 'multipart/form-data', 'x-access-token': token },
        });
        return res;
    }

    //Function to update existing content in the ecommerce manager
    static async updateContent(businessId, data, token) {
        const res = await server(`/ecommerce/${businessId}/content`, {
            method: "put",
            data: data,
            headers: { 'Content-Type': 'multipart/form-data', 'x-access-token': token },
        });
        return res;
    }
}